/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentsListQueryResponse } from "../models/WebAppGetFragmentsList";

export function getWebAppGetFragmentsListUrl() {
  const res = { method: 'GET', url: `/web-app/fragments` as const }
  return res
}

/**
 * @summary List fragments with poster, social upload statuses and external delivery status (sort, filter, limit, page)
 * {@link /web-app/fragments}
 */
export async function webAppGetFragmentsList(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetFragmentsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWebAppGetFragmentsListUrl().url.toString(), ... requestConfig })
  return res.data
}